export default {
  COPYRIGHT: '© 2024 midtones.de',
  IMPRINT: 'Impressum',
  PRIVACY: 'Datenschutzerklärung',
};
